<template>
  <v-dialog v-model="dialog" max-width="300px" @keydown.esc="cancel()">

    <v-system-bar dark dense>
      <span class="white--text">{{ title }}</span>
    </v-system-bar>

    <v-card tile>
      <v-card-text v-show="!!message">{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text outlined @click.native="agree()">Si</v-btn>
        <v-btn color="primary darken-1" text outlined @click.native="cancel()">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    data() {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
      };
    },
    methods: {
      open(title, message) {
        this.dialog = true;
        this.title = title;
        this.message = message;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      agree() {
        this.resolve(true);
        this.dialog = false;
      },
      cancel() {
        this.resolve(false);
        this.dialog = false;
      },
    },
  }
</script>